import { createSlice, createAction } from "@reduxjs/toolkit";
import listFactory from "./listFactory";
import { Account } from "./../models/Account";
import { UUID } from "../utils";
const { slicePart, selectors } = listFactory<Account>("accounts");

const initialState = {
  ...slicePart.initialState,
  item: null,
};

export const slice = createSlice({
  ...slicePart,
  initialState,
});

export const { setList, setItem, updateItem, addItem } = slice.actions;

export const fetchAccounts = createAction("fetchAccounts");
export const fetchAccount = createAction<{ id: UUID }>("fetchAccount");
export const createTempAccount = createAction("createTempAccount");
export const createAccount = createAction<{ data: Account }>("createAccount");
export const updateAccount = createAction<{ id: UUID; data: Account }>(
  "updateAccount"
);
export const setAccountActiveFlag = createAction<{
  id: UUID;
  data: Account;
}>("setAccountActiveFlag");

export const {
  selectList: selectAccounts,
  selectItem: selectAccount,
} = selectors;

export const accountsOperationPaths = (id?: UUID) => {
  return {
    listing: ["accounts", "listing"],
    details: ["accounts", "details", id],
    update: ["accounts", "update", id],
    create: ["accounts", "create"],
    setActiveFlag: ["accounts", "setActiveFlag", id],
  };
};

export default slice.reducer;
